import React, { memo } from 'react';
import { Icon, Stack, Typography, Divider, Chip } from 'investira.react.components';
import { formats } from 'investira.sdk';

const PlanoPosicao = memo(props => {
  const {
    beta,
    created,
    carteira,
    enquadramento,
    consolidacao,
    consolidacao_por_emissor,
    aberta,
    registrador
  } = props;
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack
        direction="row"
        gap={1.5}
        alignItems="center"
        sx={{
          flex: 1,
          minWidth: 0
        }}>
        {beta && (
          <>
            <Chip label="Beta" color="warning" size="small" variant="outlined" />
            <Divider orientation="vertical" flexItem />
          </>
        )}
        <Icon iconName="calendar" color="textSecondary" size={16} />
        <Typography variant="caption" color="textSecondary">
          {created && formats.formatDateCustom(created, 'DD/MM/YYYY')}
        </Typography>
        <Divider orientation="vertical" flexItem />
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{
            textTransform: 'uppercase'
          }}>
          {consolidacao_por_emissor === 'P' ? consolidacao : carteira}
        </Typography>
        <Divider orientation="vertical" flexItem />
        <Typography variant="caption" color="textSecondary">
          {`POSIÇÃO ${aberta ? `ABERTA` : 'FECHADA'}`}
        </Typography>
        {enquadramento && (
          <>
            <Divider orientation="vertical" flexItem />
            <Typography variant="caption" color="textSecondary">
              {enquadramento}
            </Typography>
          </>
        )}
        {consolidacao && consolidacao_por_emissor !== 'P' && (
          <>
            <Divider orientation="vertical" flexItem />
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                textTransform: 'uppercase'
              }}>
              Consolidação por emissor: {consolidacao}
            </Typography>
            {/* <Chip size="small" color="primary" label={consolidacao} /> */}
          </>
        )}
      </Stack>
      {registrador && (
        <Stack direction="row" alignItems="center" gap={1}>
          <Icon iconName="user" color="textSecondary" size={16} />
          <Typography variant="caption" color="textSecondary">
            {registrador}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
});

export default PlanoPosicao;
